import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import type { CustomItemProps } from '@atlassian/navigation-common/types';
import { GLOBAL_APP_MENU_ID } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Teams } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-global-apps/src/ui/teams/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './sidebarTestId.constants.tsx';

type GlobalAppMenuIdKey = keyof typeof GLOBAL_APP_MENU_ID;
export type JiraCustomItemProps = CustomItemProps & {
	menuId: (typeof GLOBAL_APP_MENU_ID)[GlobalAppMenuIdKey];
};

/**
 * This was copied from Nav4
 * - ./navigation-apps/sidebar-nav4/sidebars/content/global-apps/src/index.tsx
 * - ./navigation-apps/sidebar-nav4/sidebars/content/global-apps/src/ui/index.tsx
 * and then modified to suit GSN.
 */
export function CustomShortcutItem(props: JiraCustomItemProps): React.JSX.Element {
	return (
		<JSErrorBoundary
			fallback="flag"
			id={`gsn-custom-shortcut-item--${props.menuId}`}
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<CustomShortcutItemInner {...props} />
		</JSErrorBoundary>
	);
}

function CustomShortcutItemInner({ menuId, ...props }: JiraCustomItemProps) {
	switch (menuId) {
		case GLOBAL_APP_MENU_ID.GLOBAL_APP_TEAMS:
			return <Teams {...props} />;
		default:
			return null;
	}
}
